export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PostListing.vue?vue&type=template&id=2f3d45f2&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostListing.vue?vue&type=template&id=2f3d45f2&scoped=true
// module id = 295
// module chunks = 0